import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';

export const Image = styled.div`
    position: relative;
    width: 100%;
    height: 154px;
    background: url(${require('@static/images/lk/lk-background.png')});
    background-size: cover;
    border-radius: ${BorderRadius.OuterBlockRadius} ${BorderRadius.OuterBlockRadius} 0 0;
    
    > img {
        position: absolute;
        bottom: 0;
        left: 0;
    }
`;


